import BaseController from "./base_controller"

export default class extends BaseController {
  static targets = ['noResults']

  static values = {
    searchableCssQuery: String,
    searchableContentCssQuery: String,
    hideClass: String,
    searchableHideClass: String,
    termMinLength: { type: Number, default: 2 },
    searchDelay: { type: Number, default: 200 }
  }

  connect() {
    this.searchTimeout = null
    this.searchables = this.element.querySelectorAll(this.searchableCssQueryValue)
  }

  handleKeyup(event) {
    const term = event.currentTarget.value

    if (term.length >= this.termMinLengthValue) {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => { this.search(term) }, this.searchDelayValue)
    } else {
      this.searchables.forEach(searchable => searchable.classList.remove(this.searchableHideClassValue))
      this.noResultsTarget.classList.add(this.hideClassValue)
      this.dispatchEvent({ action: 'search', options: { detail: { hasResults: true } } })
    }
  }

  search(term) {
    const normalizedTerm = term.toLowerCase()

    this.searchables.forEach(searchable => {
      const contents = searchable.querySelectorAll(this.searchableContentCssQueryValue)

      let matches = Array.from(contents).some(label => label.textContent.toLowerCase().includes(normalizedTerm))
      matches = matches || searchable.dataset.searchTerms?.toLowerCase().includes(normalizedTerm)

      searchable.classList.toggle(this.searchableHideClassValue, !matches)
    })

    const hasResults = Array.from(this.searchables).some(searchable => !searchable.classList.contains(this.searchableHideClassValue))
    this.noResultsTarget.classList.toggle(this.hideClassValue, hasResults)

    this.dispatchEvent({ action: 'search', options: { detail: { hasResults: hasResults } } })
  }
}

